import { FeaturedTagApi } from '../../generated/api';
import configuration from './configuration';

export default new FeaturedTagApi(configuration);
